// extracted by mini-css-extract-plugin
export var centerText = "_5l-8";
export var container = "_5l-0";
export var doughnutContainer = "_5l-7";
export var legend = "_5l-a";
export var legendItemColorDisplay = "_5l-b";
export var legendItemLabel = "_5l-d";
export var legendItemValue = "_5l-c";
export var lg = "_5l-5";
export var maxWidth = "_5l-9";
export var md = "_5l-4";
export var responsive = "_5l-6";
export var sm = "_5l-3";
export var xs = "_5l-2";
export var xxs = "_5l-1";